/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useCallback } from "react";

import getNceChanges from "api/nce_changes";

import SimpleDataGrid from "components/organisms/data_grid";
import SimplePageTitle from "components/atoms/simple_page_title";
import { nce_changes_table_state, user_state } from "components/root";
import { useRecoilState } from "recoil";
import { toast } from "react-toastify";
import nce_changes_order from "constant_variables/nce_changes_fields";
import { Button, ButtonGroup } from "@mui/material";

const TENANT_OPTIONS = [
  { key: "", alias: "All" },
  { key: "BoN", alias: "BoN (CMP)" },
  { key: "1NCE", alias: "1NCE Connect (Legacy)" },
  { key: "BELL", alias: "Bell (CMP)" },
]

export default function NceChangesTable() {
  const [showData, setShowData] = useRecoilState(nce_changes_table_state);
  const [userState] = useRecoilState(user_state);
  const [loading, setLoading] = useState(true);
  const [limit, setLimit] = useState(101);
  const [tenant, setTenant] = useState("");
  const [page, setPage] = useState(0);
  let read_only = true;
  if (userState !== null && userState.permissions) {
    read_only = userState.permissions.read_only;
  }

  const getViewData = useCallback(() => {
    const request = async () => {
      try {
        setLoading(true)
        const resp = await getNceChanges({ tenant });
        const { results } = resp;
        setShowData(results);
      } catch (err) {
        console.trace(err);
        toast.error("Failed to gather data")
      } finally {
        setLoading(false);
      }
    }

    request();

  }, [limit, tenant]);

  const getAllData = () => {
    if (limit === 101) {
      setLimit(0);
      setPage(1)
    }
  }


  useEffect(() => {
    getViewData();
  }, [getViewData]);


  return (
    <>
      <SimplePageTitle title="Change Management Jira" />
      <ButtonGroup>
        {
          TENANT_OPTIONS.map((k) =>
            <Button
              variant="contained"
              key={k.key}
              disabled={false}
              onClick={() => setTenant(k.key)}
              sx={{ backgroundColor: k.key === tenant ? "29abe2" : "#1e4d7d", color: "white" }}
            >
              {k.alias}
            </Button>)
        }
      </ButtonGroup>
      <SimpleDataGrid
        loading={loading}
        data={showData}
        order={nce_changes_order}
        id={false}
        getAllData={getAllData}
        page={page}
        setPage={setPage}
      />
    </>
  );
}
